import FetchService from './base.fetch';

/**
 * 数据服务
 * 
 * @export
 * @class QiniuService
 */
class QiniuService {

    /**
     * Creates an instance of QiniuService.
     * @memberof QiniuService
     */
    constructor() {
        this.domain = FetchService.domainconfig.gateway;

        const apisConfig = {
            // 获取七牛 token
            token: {
                method: 'post',
                url: 'Qiniu/GetUploadToken',
            },
            url: {
                method: 'post',
                url: 'Qiniu/GetDownloadUrl'
            }
        };

        FetchService.configToRequestAction.call(this, apisConfig, FetchService);
    }
}

export default new QiniuService();